<template>
    <kw-common-pc-lyfootbar></kw-common-pc-lyfootbar>
</template>
<script>
import { mapMutations } from 'vuex'
import {http} from '@utils'

export default {
    name: 'popFooter',
    data(){
        return {
            bg:'',
            nav:[],
            tag:[]
        }
    },
    async created(){
        // const response = await http.get('//cms.haiziwang.com/publish/976/pop-footer.json');
        // if(response && response.data) {
        //     const res = response.data;
        //     this.bg = res.bg;
        //     this.nav = res.nav;
        //     this.tag = res.tag;
        //     this.setFooterInfo(res)
        // }
    },
    methods: {
        ...mapMutations(['setFooterInfo'])
    }
}
</script>

<style lang="scss" scoped>
 footer {
     width: 100%;
     height: 120px;
     background: url('~@assets/images/footer_bg@2x.png') no-repeat;
     background-size: cover;
     @include Flex;
     justify-content: center;
     .foot-content {
          @include Flex;
         @include Width;
         flex-direction: column;

         .list-ui
         {
              @include Flex;
            @include Width;
            justify-content: center;
            padding-top: 32px;
             article {
                padding: 0 28px;
                position: relative;
                &:after {
                    content: "";
                    position: absolute;
                    right: 0;
                    height: 11px;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 1px;
                    background: #D0D9ED;
                }
                &:last-child:after {
                    width: 0;
                }
                a {
                    font-size: 15px;
                    color: #D0D9ED;
                }


             }
         }
         .tag-ui {
            @include Flex;
            @include Width;
            margin-top: 16px;
            justify-content: center;

            p {
                position: relative;
                font-size: 14px;
                color: #8A93A7;
                padding: 0 10px;
                padding-right: 14px;
                &:after {
                    content: "/";
                    color: #8A93A7;
                    position: absolute;
                    right: -5px;
                    height: 18px;
                    top: 50%;
                    font-size: 11px;
                    transform: translateY(-50%);
                    width: 10px;
                }
                &:last-child:after {
                    content:"";
                }
            }
         }
     }
 }
</style>


